import React from "react";
import { useTranslation } from 'next-i18next';

const languageOptions = {
    default: 'pt',
    ptBR: 'pt-BR',
}

export default function useSelectedLanguageCode() {
    const { i18n, t } = useTranslation();

    const getSelectedLanguageCode = () => {
        if (i18n.language === languageOptions.ptBR) {
            return languageOptions.default;
        }

        return i18n.language;
    }

    return getSelectedLanguageCode();
}
